import React from "react";
import { FlexCenter } from "../../../constant/CustomeStyle";
import DateRangeBar from "../WorkPeriod/DateRangeBar";
import DataTable from "./DataTable";

const Tickets = () => {
  return (
    <div style={{ minWidth: 1190, marginRight: 20, marginTop: 20 }}>
      <DateRangeBar />

      <FlexCenter style={{ marginTop: 10 }}>
        <DataTable />
      </FlexCenter>
    </div>
  );
};

export default Tickets;
